import React from "react";
import { Link } from "react-router-dom";
import { Menu, Grid, Button } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import navigationConfig from "configs/NavigationConfig";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from "utils";
import { onMobileNavToggle } from "redux/actions/Theme";
import { ApiService } from "services/api/ApiService";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const createSampleBid = () => {
  ApiService.post("/bid/create", sampleBid())
    .catch((error) => console.log(error))
    .then(() => window.location.reload());
};

const SideNavContent = (props) => {
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
    user,
  } = props;
  //console.log("user", user);
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };
  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <Menu.ItemGroup
            key={menu.key}
            title={setLocale(localization, menu.title)}
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  key={subMenuFirst.key}
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      {subMenuSecond.icon ? (
                        <Icon type={subMenuSecond?.icon} />
                      ) : null}
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link
                        onClick={() => closeMobileNav()}
                        to={subMenuSecond.path}
                      />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (subMenuFirst.key !== "create" &&
                  subMenuFirst.key !== "logs" &&
                  subMenuFirst.key !== "user-list") ||
                user.admin ? (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link
                    onClick={() => closeMobileNav()}
                    to={subMenuFirst.path}
                  />
                </Menu.Item>
              ) : null
            )}
          </Menu.ItemGroup>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? (
              <Link onClick={() => closeMobileNav()} to={menu.path} />
            ) : null}
          </Menu.Item>
        )
      )}
      {user.admin && (
        <Menu.Item style={{ marginTop: "100px" }} key={"subasta"}>
          <Button onClick={() => createSampleBid()}>
            {" "}
            Crear subasta de prueba{" "}
          </Button>
        </Menu.Item>
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? <SideNavContent {...props} /> : null;
};

const mapStateToProps = ({ theme, auth }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor, user: auth.user };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);

const sampleBid = () => {
  var OneMinutesLater = new Date();
  OneMinutesLater.setMinutes(OneMinutesLater.getMinutes() + 1);

  var fiveMinutesLater = new Date();
  fiveMinutesLater.setMinutes(fiveMinutesLater.getMinutes() + 3);

  return {
    bids: [
      {
        active: false,
        finish: false,
        _id: "633320a5b048f800377e875d",
        reference: "LOTE 1",
        minimunAmount: 100000,
        increment: 10000,
        accountsNumber: 300,
        icons: [
          {
            icon: "ItalicOutlined",
            title: "Mercado primario",
          },
          {
            icon: "AlertOutlined",
            title: "Judicializada",
          },
          {
            icon: "UserDeleteOutlined",
            title: "100% Deuda persona física",
          },
          {
            icon: "FileProtectOutlined",
            title: "Expedientes Completos",
          },
        ],
        dpd: 180,
        totalDebt: 1000000,
        totalDebtMed: 1080,
        mainDebt: "750000",
        mainDebtMed: 820,
        info: "SIN RECOBRO AMISTOSO",
        documents: [
          {
            _id: "625692a099b835003887c056",
            fieldname: "docs",
            originalname:
              "Fintonic_for publication ( Toda la Cartera) compramps el LOTE 3.xlsx",
            encoding: "7bit",
            mimetype:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            destination: "./uploads/6256925199b835003887c053",
            filename:
              "Fintonic_for publication ( Toda la Cartera) compramps el LOTE 3.xlsx",
            path: "uploads/6256925199b835003887c053/Fintonic_for publication ( Toda la Cartera) compramps el LOTE 3.xlsx",
            size: "193635",
          },
        ],
        data: [],

        /* autobuyers: {
          "6291e01d273739003872d71c": {
            maxbid: 150000,
            bid_id: "6256933a99b835003887c059",
            subbid_id: "6256933a99b835003887c059",
          },
          "6291d483d47d5c6d34f4afc3": {
            bid_id: "6256933a99b835003887c059",
            maxbid: 175000,
            subbid_id: "6256933a99b835003887c059",
          },
          "62b1b2a80e2d2200375e39e3": {
            bid_id: "6256933a99b835003887c059",
            maxbid: 185000,
            subbid_id: "6256933a99b835003887c059",
          },
        }, */
      },
      {
        active: false,
        finish: false,
        _id: "6256933a99b835003887c05b",
        reference: "LOTE 2",
        minimunAmount: 17500,
        increment: 2500,
        accountsNumber: 750,
        icons: [
          {
            icon: "BankOutlined",
            title: "No judicializada",
          },
          {
            icon: "UserDeleteOutlined",
            title: "100% Deuda persona física",
          },
        ],
        dpd: 500,
        totalDebt: 250000,
        totalDebtMed: 320,
        mainDebt: "190000",
        mainDebtMed: 285,
        info: "CON RECOBRO AMISTOSO",
        documents: [],
        data: [],
      },
    ],
    end_time: `${fiveMinutesLater}`,
    globalIcons: [
      {
        icon: "ItalicOutlined",
        title: "Mercado primario",
      },
      {
        icon: "UserAddOutlined",
        title: "100% Deuda persona jurídica",
      },
    ],
    selectedUsers: ["628f6703c61b653ee76f08e2", "6291e01d273739003872d71c"],
    seller: "6291e01d273739003872d71c",
    starting_time: `${OneMinutesLater}`,
    title: "PULPO FINANCE 3",
    updatedAt: "2022-04-13T10:55:10.665Z",
    postman: "true",
  };
};
